import { useEffect, useState } from 'react'
import { Position, Transform } from 'types'

const useDraggedPosition = (defaultPosition: Position, transform: Transform): Position => {
    const [position, setPosition] = useState<Position>(defaultPosition)
    const { x: defaultX, y: defaultY, width: defaultWidth, height: defaultHeight } = defaultPosition
    const { x, y, scaleX, scaleY, rotation } = transform

    useEffect(() => {
        setPosition({
            height: Math.round(defaultHeight * scaleY),
            rotation,
            width: Math.round(defaultWidth * scaleX),
            x: Math.round(defaultX + x),
            y: Math.round(defaultY + y),
        })
    }, [defaultX, defaultY, defaultWidth, defaultHeight, x, y, scaleX, scaleY, rotation])

    return position
}

export default useDraggedPosition
